import React, { memo } from 'react'
import { useRadioInput, RadioInputProps } from './useRadioInput'
import styles from './RadioInput.module.scss'

const RadioInput: React.FC<RadioInputProps> = (props: RadioInputProps) => {
  const { label, icon, name, value, isChecked, onChange } = useRadioInput(props)

  return (
    <label>
      <input
        className={styles['radio-input']}
        type='radio'
        name={name}
        checked={isChecked}
        onChange={() => onChange(value)}
      />
      <span className={styles['radio-title']}>
        <span className={styles['radio-icon']}>
          <i className={`bi bi-${icon}`}></i>
        </span>
        <span className={styles['radio-label']}>{label}</span>
      </span>
    </label>
  )
}

export default memo(RadioInput)
